import { c as _c } from "react/compiler-runtime";
import type React from 'react';
type CardItemProps = {
  label: string | React.ReactNode;
  value: string | React.ReactNode;
};
export function LoanItem(t0) {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <dt className="card-item-label">{label}</dt>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = <dd className="card-item-value">{value}</dd>;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <dl className="card-item py-2!">{t1}{t2}</dl>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}